module.exports = __webpack_public_path__ + "9924623cfd0844c2bd986b5e8e5c83a0.svg";